var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('InventoryMapFilters',{on:{"change":_vm.updateFilter}})],1),_c('b-col',{attrs:{"cols":"9"}},[_c('FilteredMap',{attrs:{"filters":_vm.filters}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }